import { render } from "./CardPendencia.vue?vue&type=template&id=90827aca"
import script from "./CardPendencia.vue?vue&type=script&lang=js"
export * from "./CardPendencia.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__